import React, { Component, PropTypes } from 'react';
import { ThemeStore } from 'stores';
import { StoreOverviewActions } from 'actions';
import * as SvgIcons from 'components/Material/SvgIcons';
import { FormattedNumber } from 'react-intl';
import { Units, Shadow, Colors } from 'Css';
import { TagList } from 'components/Tags';
import { List, ListItem } from 'components/List';

const css = oxygenCss({
  root: {
    padding: `${Units.base * 2}px 0`
  },
  buyButton: {
    cursor: 'pointer',
    borderRadius: 2,
    boxShadow: Shadow[1],
    backgroundColor: '#FF5555',
    minWidth: 64,
    textAlign: 'center',
    lineHeight: '24px',
    padding: `${Units.base / 2}px ${Units.base}px`,
    color: Colors.fullWhite,
    fontWeight: 500,
    margin: `0 ${Units.base}px`,
    alignSelf: 'center',
    // flex: '0 1 96px',
    flexGrow: 0,
    flexShrink: 0,
    width: 96,
    '@phone': {
      flex: 1,
      alignSelf: 'stretch',
      margin: 0
    }
  },
  giftButton: {
    cursor: 'pointer',
    borderRadius: 2,
    boxShadow: Shadow[1],
    backgroundColor: '#FF55FF',
    minWidth: 64,
    textAlign: 'center',
    lineHeight: '24px',
    padding: `${Units.base / 2}px ${Units.base}px`,
    color: Colors.fullWhite,
    fontWeight: 500,
    margin: `0 ${Units.base}px`,
    alignSelf: 'center',
    // flex: '0 1 96px',
    flexGrow: 0,
    flexShrink: 0,
    width: 96,
    '@phone': {
      flex: 1,
      alignSelf: 'stretch',
      margin: 0
    }
  },
  description: {
    fontSize: 14,
    whiteSpace: 'normal',
    ' UL': {
      margin: Units.base
    },
    ' OL': {
      margin: Units.base
    }
  },
  detail: {
    position: 'relative',
    paddingLeft: 104,
    // flex: '1 0 auto',
    flexGrow: 1,
    '@phone': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'pre-wrap'
    }
  },
  packBadge: {
    lineHeight: '24px',
    padding: `${Units.base / 2}px ${Units.base}px`,
    color: Colors.fullWhite,
    fontWeight: 500,
    boxShadow: Shadow[1],
    position: 'absolute',
    left: `${-Units.base * 2}px`,
    top: Units.base,
    '@phone': {
      left: 0
    },
    '>SVG': {
      verticalAlign: 'middle'
    }
  },
  controls: {
    '@phone': {
      display: 'flex',
      width: '100%'
    }
  },
  price: {},
  header: {
    fontSize: 20,
    lineHeight: '32px'
  },
  cover: {
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    borderRadius: 2,
    boxShadow: Shadow[1],
    width: 96,
    height: 64,
    position: 'absolute',
    left: 4,
    top: '50%',
    marginTop: -32
  }
});

class StoreList extends Component {
  static propTypes = {
    username: PropTypes.string,
    items: PropTypes.array,
    canIEdit: PropTypes.bool,
    themeColor: PropTypes.string,
    onTouchTapItem: PropTypes.func,
    cart: PropTypes.array
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  onTouchTap = storeItem => {
    const { onTouchTapItem } = this.props;
    if (onTouchTapItem) {
      onTouchTapItem(storeItem);
    } else {
      const { type, slug } = storeItem;
      StoreOverviewActions.findBySlug(type, slug);
    }
  };

  buyItem = (storeItem, event) => {
    StoreOverviewActions.addToCart(storeItem);
    event.preventDefault();
    event.stopPropagation();
  };

  render() {
    const { items, canIEdit, themeColor } = this.props;
    return (
      <List>
        {items.map(storeItem => {
          const { price, currency, type, id, name } = storeItem;
          const coverImages = storeItem.coverImage;
          const coverImage =
            (coverImages.length && coverImages.length > 0 && coverImages[0]) ||
            {};
          return (
            <ListItem
              padded={false}
              card
              responsive
              key={storeItem.type + '-' + id}
              payload={storeItem}
              onTouchTap={this.onTouchTap}
            >
              <div className={css.detail}>
                <div
                  className={css.cover}
                  style={{
                    backgroundColor:
                      (!canIEdit && ThemeStore.getColor(themeColor, 0.5)) ||
                      'rgba(0, 0, 0, 0.5)',
                    backgroundImage: coverImage.id && `url(${coverImage.url})`
                  }}
                />
                <div className={css.header}>{name}</div>
                <div
                  className={css.description}
                  dangerouslySetInnerHTML={{ __html: storeItem.description }}
                />
                <div className={css.price}>
                  <FormattedNumber
                    style="currency"
                    currency={currency}
                    value={Math.round(price.discounted)}
                  />
                </div>
                <TagList dense tags={storeItem.tagsMap} />
                {type === 2 && (
                  <div
                    className={css.packBadge}
                    style={{ backgroundColor: ThemeStore.getColor(themeColor) }}
                  >
                    {storeItem.courses.length}
                    <SvgIcons.ActionViewModule color={Colors.fullWhite} />
                  </div>
                )}
              </div>
              <div
                onTouchTap={this.buyItem.bind(this, storeItem)}
                className={css.buyButton}
              >
                {this.context.getIntlMessage('store.joinCourse')}
              </div>
              <div
                onTouchTap={this.buyItem.bind(this, storeItem)}
                className={css.giftButton}
              >
                {this.context.getIntlMessage('store.giftCourse')}
              </div>
            </ListItem>
          );
        })}
      </List>
    );
  }
}

export default StoreList;



// WEBPACK FOOTER //
// ./src/js/components/Store/StoreList.js